export const Types = {
  // Deleta uma Atividade
  GET_DELETE_REQUEST: 'activity/GET_DELETE_REQUEST',
  GET_DELETE_SUCCESS: 'activity/GET_DELETE_SUCCESS',
  GET_DELETE_FAILURE: 'activity/GET_DELETE_FAILURE',
};

export const initialState = {
  // Deleta uma Atividade
  activityDeleteLoading: false,
  activityDeleteError: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    // Deleta uma Atividade
    case Types.GET_DELETE_REQUEST:
      return { ...state, activityDeleteLoading: true };
    case Types.GET_DELETE_SUCCESS:
      return {
        activityDeleteLoading: false,
        activityDeleteError: null,
      };
    case Types.GET_DELETE_FAILURE:
      return {
        activityDeleteLoading: false,
        activityDeleteError: action.payload,
      };
    default:
      return state;
  }
};

export const Creators = {
  // Deleta uma Atividade
  getActivityDeleteRequest: id => ({
    type: Types.GET_DELETE_REQUEST,
    payload: { id },
  }),
  getActivityDeleteSuccess: () => ({
    type: Types.GET_DELETE_SUCCESS,
  }),
  getActivityDeleteFailure: error => ({
    type: Types.GET_DELETE_FAILURE,
    payload: error,
  }),
};